import { TipoTopicoNotificacaoEnum } from 'graphql/types.generated'
import { useMemo } from 'react'

import { InscricaoNotificacaoItem } from './notificacao-context/model-notificacaoContext'
import { useInscricoesTopicosNotificacaoContext } from './notificacao-context/useNotificacaoContext'

type OpcoesFiltro = {
  filtrarPor: 'lido' | 'visto'
}

export function useTopicoNotificacaoFiltered(
  tipoTopico: TipoTopicoNotificacaoEnum,
  options?: OpcoesFiltro
): InscricaoNotificacaoItem[] {
  const { filtrarPor } = options ?? {}
  const inscricoesTopicos = useInscricoesTopicosNotificacaoContext()
  const topicoEspecifico = inscricoesTopicos[tipoTopico]

  const registroIds = useMemo(() => {
    if (!topicoEspecifico) {
      return []
    }

    const filtroPredicate = (value: InscricaoNotificacaoItem): boolean => {
      switch (filtrarPor) {
        case 'lido':
          return value.statusNotificarLido
        case 'visto':
          return value.statusNotificarVisto
        default:
          return true
      }
    }

    return Object.entries(topicoEspecifico)
      .filter(([_, value]) => filtroPredicate(value))
      .map(([_, value]) => value)
  }, [topicoEspecifico, filtrarPor])

  return registroIds
}
